import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 p-8 text-center">
      <h1 className="text-2xl font-semibold text-[var(--cad-text,#f4f4f5)]">404</h1>
      <p className="text-sm text-[var(--cad-text-muted,#a1a1aa)]">That page doesn’t exist.</p>
      <Link to="/dashboard" className="text-sm text-[var(--cad-accent,#818cf8)] hover:text-[var(--cad-accent,#a5b4fc)]">
        Back to dashboard
      </Link>
    </div>
  );
}
